var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      ref: "driverDetail",
      attrs: {
        visible: _vm.drawer,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "60%",
        withHeader: "false",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawer = $event
        },
        open: _vm.openDetail,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: { display: "flex", "align-items": "center" },
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("div", [_vm._v("驾驶员-" + _vm._s(_vm.info.name))]),
          _c("div", { staticClass: "tips_box" }, [
            _vm._v(
              "注意：该模块信息用于上传至交通部门监管信息平台，请保持信息完整与正确性！"
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticStyle: {
            padding: "0 0 10px 20px",
            color: "#606266",
            "font-size": "14px",
          },
        },
        [
          _c("span", [_vm._v("信息完整度：")]),
          _c("span", [
            _vm._v(
              _vm._s(_vm.info.completeRate ? _vm.info.completeRate + "%" : "")
            ),
          ]),
        ]
      ),
      _c("div", { staticClass: "top_box" }, [
        _c("div", { staticClass: "dian" }),
        _c("div", { staticStyle: { "margin-right": "20px" } }, [
          _vm._v(
            _vm._s(
              _vm.info.auditState === 1
                ? "待审核"
                : _vm.info.auditState === 2
                ? "审核通过"
                : "拒绝"
            ) + "\n    "
          ),
        ]),
        _vm.info.auditState === 1
          ? _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["driver_audit"],
                        expression: "['driver_audit']",
                      },
                    ],
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.auditClick(2)
                      },
                    },
                  },
                  [_vm._v("通过")]
                ),
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "has-permi",
                        rawName: "v-has-permi",
                        value: ["driver_audit"],
                        expression: "['driver_audit']",
                      },
                    ],
                    attrs: { size: "small", type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.auditClick(3)
                      },
                    },
                  },
                  [_vm._v("不通过")]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "基础信息", name: "first" } },
            [
              _c(
                "el-row",
                { attrs: { gutter: 40 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticStyle: { "margin-left": "40px" },
                          attrs: { column: 1 },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            {
                              attrs: {
                                label: "归属供应商",
                                prop: "merchantName",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.info.merchantName) + "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "身份证号" } },
                            [_vm._v(_vm._s(_vm.info.identityCard))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "身份证有效期起" } },
                            [_vm._v(_vm._s(_vm.info.idCardOn))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "身份证有效期止" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.idCardOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.idCardOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [_vm._v(_vm._s(_vm.info.idCardOff))]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.idCardOff === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.idCardOff === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.idCardOff === "expiringSoon"
                                        ? "即将过期"
                                        : _vm.idCardOff === "expire"
                                        ? "已过期"
                                        : ""
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "性别" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.info.sex === 1
                                    ? "男"
                                    : _vm.info.sex === 2
                                    ? "女"
                                    : "其他"
                                ) + "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "婚姻状况" } },
                            [_vm._v(_vm._s(_vm.info.maritalStatus))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "身份证地址" } },
                            [_vm._v(_vm._s(_vm.info.address))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "现住址" } },
                            [_vm._v(_vm._s(_vm.info.contactAddress))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "紧急联系电话" } },
                            [_vm._v(_vm._s(_vm.info.emergencyContactPhone))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "教育程度" } },
                            [_vm._v(_vm._s(_vm.info.educational))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "驾驶证号" } },
                            [_vm._v(_vm._s(_vm.info.licenseid) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "驾驶证初领日期" } },
                            [_vm._v(_vm._s(_vm.info.licenseDate))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "驾驶证有效期止" } },
                            [
                              _c(
                                "span",
                                {
                                  style:
                                    _vm.licenseDuedate === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.licenseDuedate === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [_vm._v(_vm._s(_vm.info.licenseDuedate))]
                              ),
                              _c(
                                "span",
                                {
                                  staticStyle: { "margin-left": "10px" },
                                  style:
                                    _vm.licenseDuedate === "expiringSoon"
                                      ? "color: #FF881B"
                                      : _vm.licenseDuedate === "expire"
                                      ? "color: #FA5151"
                                      : "",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.licenseDuedate === "expiringSoon"
                                        ? "即将过期"
                                        : _vm.licenseDuedate === "expire"
                                        ? "已过期"
                                        : ""
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "手机型号" } },
                            [_vm._v(_vm._s(_vm.info.mobileMode) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "司机照片" } },
                            [
                              _c(
                                "el-image",
                                {
                                  staticStyle: {
                                    width: "100px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    src: _vm.info.headImg,
                                    "preview-src-list": _vm.previewList,
                                  },
                                },
                                [
                                  _c("template", { slot: "error" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-bg-f6 full flex-center color-999",
                                      },
                                      [_vm._v("暂未上传图片")]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "驾驶证" } },
                            [
                              _c("div", { staticClass: "flex flex-col" }, [
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.licenseDuedate === "expiringSoon"
                                        ? "color: #FF881B"
                                        : _vm.licenseDuedate === "expire"
                                        ? "color: #FA5151"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.licenseDuedate === "expiringSoon"
                                          ? "证照即将过期，请及时办理更新"
                                          : _vm.licenseDuedate === "expire"
                                          ? "证照已过期，请及时办理更新"
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "img_box" },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticStyle: {
                                            width: "120px",
                                            height: "100px",
                                            "margin-right": "20px",
                                          },
                                          attrs: {
                                            src: _vm.info.licensePhotoFront,
                                            "preview-src-list": _vm.previewList,
                                          },
                                        },
                                        [
                                          _c("template", { slot: "error" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-bg-f6 full flex-center color-999",
                                              },
                                              [_vm._v("暂未上传图片")]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c("span", [_vm._v("驾驶证（正页）")]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "img_box" },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticStyle: {
                                            width: "120px",
                                            height: "100px",
                                          },
                                          attrs: {
                                            src: _vm.info.licensePhotoSubpage,
                                            "preview-src-list": _vm.previewList,
                                          },
                                        },
                                        [
                                          _c("template", { slot: "error" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-bg-f6 full flex-center color-999",
                                              },
                                              [_vm._v("暂未上传图片")]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c("span", [_vm._v("驾驶证（副页）")]),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "身份证" } },
                            [
                              _c("div", { staticClass: "flex flex-col" }, [
                                _c(
                                  "span",
                                  {
                                    style:
                                      _vm.idCardOff === "expiringSoon"
                                        ? "color: #FF881B"
                                        : _vm.idCardOff === "expire"
                                        ? "color: #FA5151"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.idCardOff === "expiringSoon"
                                          ? "证照即将过期，请及时办理更新"
                                          : _vm.idCardOff === "expire"
                                          ? "证照已过期，请及时办理更新"
                                          : ""
                                      )
                                    ),
                                  ]
                                ),
                                _c("div", { staticClass: "flex" }, [
                                  _c(
                                    "div",
                                    { staticClass: "img_box" },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticStyle: {
                                            width: "120px",
                                            height: "100px",
                                            "margin-right": "20px",
                                          },
                                          attrs: {
                                            src: _vm.info.idcardPhotoPositive,
                                            "preview-src-list": _vm.previewList,
                                          },
                                        },
                                        [
                                          _c("template", { slot: "error" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-bg-f6 full flex-center color-999",
                                              },
                                              [_vm._v("暂未上传图片")]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c("span", [_vm._v("身份证（正面）")]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "img_box" },
                                    [
                                      _c(
                                        "el-image",
                                        {
                                          staticStyle: {
                                            width: "120px",
                                            height: "100px",
                                          },
                                          attrs: {
                                            src: _vm.info.idcardPhotoReverse,
                                            "preview-src-list": _vm.previewList,
                                          },
                                        },
                                        [
                                          _c("template", { slot: "error" }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-bg-f6 full flex-center color-999",
                                              },
                                              [_vm._v("暂未上传图片")]
                                            ),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _c("span", [_vm._v("身份证（背面）")]),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-descriptions",
                        { attrs: { column: 1 } },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "手机号码" } },
                            [_vm._v(_vm._s(_vm.info.mobilePhone) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "出生日期" } },
                            [_vm._v(_vm._s(_vm.info.birthday))]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "国籍" } },
                            [_vm._v(_vm._s(_vm.info.nationality) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "民族" } },
                            [_vm._v(_vm._s(_vm.info.nation) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "户口登记机关" } },
                            [
                              _vm._v(
                                _vm._s(_vm.info.driverCensus) + "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "紧急联系人" } },
                            [
                              _vm._v(
                                _vm._s(_vm.info.emergencyContact) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "紧急联系地址" } },
                            [
                              _vm._v(
                                _vm._s(_vm.info.emergencyContactAddress) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "外语能力" } },
                            [_vm._v(_vm._s(_vm.info.language) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "准驾车型" } },
                            [_vm._v(_vm._s(_vm.info.licenseType) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "驾驶证有效期起" } },
                            [
                              _vm._v(
                                _vm._s(_vm.info.licenseStartDate) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "司机注册城市" } },
                            [_vm._v(_vm._s(_vm.info.areaName) + " ")]
                          ),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "手机运营商" } },
                            [
                              _vm._v(
                                _vm._s(_vm.info.mobileOperator) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "运营登记", name: "second" } },
            [
              _c(
                "el-descriptions",
                {
                  staticStyle: { "margin-left": "40px" },
                  attrs: { column: 1 },
                },
                [
                  _c("el-descriptions-item", { attrs: { label: "运营类型" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.info.operationType === 1
                          ? "道路运输"
                          : _vm.info.operationType === 2
                          ? "网络预约"
                          : ""
                      ) + "\n        "
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合同签署公司" } },
                    [_vm._v(_vm._s(_vm.info.contractCompany))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "驾驶员证发证机构" } },
                    [_vm._v(_vm._s(_vm.info.netCarissueOrganization))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "初次领取资格证日期" } },
                    [_vm._v(_vm._s(_vm.info.getNetCarProofDate))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资格证发证日期" } },
                    [_vm._v(_vm._s(_vm.info.netCarissueDate))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资格证有效起始日期" } },
                    [_vm._v(_vm._s(_vm.info.netCarproofOn))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "资格证有效截止日期" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.netCarproofOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.netCarproofOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.info.netCarproofOff))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.netCarproofOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.netCarproofOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.netCarproofOff === "expiringSoon"
                                ? "即将过期"
                                : _vm.netCarproofOff === "expire"
                                ? "已过期"
                                : ""
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "驾驶员资格证号" } },
                    [_vm._v(_vm._s(_vm.info.netTaxiDriveLicenseid))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合同有效期起" } },
                    [_vm._v(_vm._s(_vm.info.contractOn))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "合同有效期止" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.contractOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.contractOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.info.contractOff))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.contractOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.contractOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.contractOff === "expiringSoon"
                                ? "即将过期"
                                : _vm.contractOff === "expire"
                                ? "已过期"
                                : ""
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "报备日期" } }, [
                    _vm._v(_vm._s(_vm.info.reportDate)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "驾驶员证下次考核日期" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.carHailingLicenseOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.carHailingLicenseOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.info.carHailingLicenseOff))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.carHailingLicenseOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.carHailingLicenseOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.carHailingLicenseOff === "expiringSoon"
                                ? "即将过期"
                                : _vm.carHailingLicenseOff === "expire"
                                ? "已过期"
                                : ""
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "网约车驾驶员证" } },
                    [
                      _c("div", { staticClass: "flex flex-col" }, [
                        _c(
                          "span",
                          {
                            style:
                              _vm.netCarproofOff === "expiringSoon"
                                ? "color: #FF881B"
                                : _vm.netCarproofOff === "expire"
                                ? "color: #FA5151"
                                : "",
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.netCarproofOff === "expiringSoon"
                                  ? "证照即将过期，请及时办理更新"
                                  : _vm.netCarproofOff === "expire"
                                  ? "证照已过期，请及时办理更新"
                                  : ""
                              )
                            ),
                          ]
                        ),
                        _c("div", { staticClass: "flex" }, [
                          _c(
                            "div",
                            { staticClass: "img_box" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    height: "100px",
                                    "margin-right": "20px",
                                  },
                                  attrs: {
                                    src: _vm.info.netLicensePhotoFront,
                                    "preview-src-list": _vm.previewList,
                                  },
                                },
                                [
                                  _c("template", { slot: "error" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-bg-f6 full flex-center color-999",
                                      },
                                      [_vm._v("暂未上传图片")]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                              _c("span", [_vm._v("网约车驾驶员证（信息页）")]),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "img_box" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticStyle: {
                                    width: "120px",
                                    height: "100px",
                                  },
                                  attrs: {
                                    src: _vm.info.netLicensePhotoSubpage,
                                    "preview-src-list": _vm.previewList,
                                  },
                                },
                                [
                                  _c("template", { slot: "error" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "color-bg-f6 full flex-center color-999",
                                      },
                                      [_vm._v("暂未上传图片")]
                                    ),
                                  ]),
                                ],
                                2
                              ),
                              _c("span", [
                                _vm._v("网约车驾驶员（考核记录页）"),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  Object.keys(_vm.info).length
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "驾驶员体检证明" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col flex-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(
                                  _vm.info.medicalCertificate.split(","),
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _vm.isImage(item) || !item
                                          ? _c(
                                              "el-image",
                                              {
                                                class:
                                                  _vm.info.medicalCertificate.split(
                                                    ","
                                                  ).length > 1
                                                    ? "margin-right-20"
                                                    : "",
                                                staticStyle: {
                                                  width: "120px",
                                                  height: "100px",
                                                },
                                                attrs: {
                                                  src: item,
                                                  "preview-src-list": [item],
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "error" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-bg-f6 full flex-center color-999",
                                                      },
                                                      [_vm._v("暂未上传图片")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-12 color-999 box",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleDownload(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document font-18",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "line-1 font-16",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getFileName(item)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "span",
                                { staticClass: "font-12 margin-top-10" },
                                [_vm._v("驾驶员体检证明")]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-descriptions-item", { attrs: { label: "体检日期" } }, [
                    _vm._v(_vm._s(_vm.info.medicalCertificateOn)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "体检有效期止" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.medicalCertificateOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.medicalCertificateOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.info.medicalCertificateOff))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.medicalCertificateOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.medicalCertificateOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.medicalCertificateOff === "expiringSoon"
                                ? "即将过期"
                                : _vm.medicalCertificateOff === "expire"
                                ? "已过期"
                                : ""
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  Object.keys(_vm.info).length
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "驾驶员毒检证明" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col flex-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(
                                  _vm.info.drugCertificate.split(","),
                                  function (item, index) {
                                    return _c(
                                      "div",
                                      { key: index },
                                      [
                                        _vm.isImage(item) || !item
                                          ? _c(
                                              "el-image",
                                              {
                                                class:
                                                  _vm.info.drugCertificate.split(
                                                    ","
                                                  ).length > 1
                                                    ? "margin-right-20"
                                                    : "",
                                                staticStyle: {
                                                  width: "120px",
                                                  height: "100px",
                                                },
                                                attrs: {
                                                  src: item,
                                                  "preview-src-list": [item],
                                                },
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "error" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-bg-f6 full flex-center color-999",
                                                      },
                                                      [_vm._v("暂未上传图片")]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              2
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-12 color-999 box",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleDownload(
                                                      item
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-document font-18",
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "line-1 font-16",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getFileName(item)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                              _c(
                                "span",
                                { staticClass: "font-12 margin-top-10" },
                                [_vm._v("驾驶员毒检证明")]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-descriptions-item", { attrs: { label: "毒检日期" } }, [
                    _vm._v(_vm._s(_vm.info.drugCertificateOn)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "毒检有效期止" } },
                    [
                      _c(
                        "span",
                        {
                          style:
                            _vm.drugCertificateOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.drugCertificateOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [_vm._v(_vm._s(_vm.info.drugCertificateOff))]
                      ),
                      _c(
                        "span",
                        {
                          staticStyle: { "margin-left": "10px" },
                          style:
                            _vm.drugCertificateOff === "expiringSoon"
                              ? "color: #FF881B"
                              : _vm.drugCertificateOff === "expire"
                              ? "color: #FA5151"
                              : "",
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.drugCertificateOff === "expiringSoon"
                                ? "即将过期"
                                : _vm.drugCertificateOff === "expire"
                                ? "已过期"
                                : ""
                            )
                          ),
                        ]
                      ),
                    ]
                  ),
                  Object.keys(_vm.info).length
                    ? _c(
                        "el-descriptions-item",
                        { attrs: { label: "交管12123截图" } },
                        [
                          _c(
                            "div",
                            { staticClass: "flex flex-col flex-center" },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                _vm._l(
                                  _vm.info.trafficManagement.split(","),
                                  function (item, index) {
                                    return _c(
                                      "el-image",
                                      {
                                        key: index,
                                        class:
                                          _vm.info.trafficManagement.split(",")
                                            .length > 1
                                            ? "margin-right-20"
                                            : "",
                                        staticStyle: {
                                          width: "120px",
                                          height: "100px",
                                        },
                                        attrs: {
                                          src: item,
                                          "preview-src-list": _vm.previewList,
                                        },
                                      },
                                      [
                                        _c("template", { slot: "error" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "color-bg-f6 full flex-center color-999",
                                            },
                                            [_vm._v("暂未上传图片")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    )
                                  }
                                ),
                                1
                              ),
                              _c(
                                "span",
                                { staticClass: "font-12 margin-top-10" },
                                [_vm._v("交管12123截图")]
                              ),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("el-tab-pane", { attrs: { label: "操作日志", name: "third" } }, [
            _c(
              "div",
              { staticClass: "padding-x-10" },
              [
                _c("operation-log", {
                  attrs: { list: _vm.logList, maxHeight: _vm.logTableHeight },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }